import { AuthUIProvider } from "./AuthUIContext";
import { AuthUIRootPages } from "./AuthUIRootPages";
import { SignInPage } from "./pages/SignInPage";

// MENU
import { SignUpPage } from "./pages/SignUpPage";

export const AuthRoutes = [
  {
    path: "/auth/sign-in",
    element: (
      <AuthUIProvider>
        <AuthUIRootPages>
          <SignInPage />
        </AuthUIRootPages>
      </AuthUIProvider>
    ),
  },
  {
    path: "/auth/sign-up",
    element: (
      <AuthUIProvider>
        <AuthUIRootPages>
          <SignUpPage />
        </AuthUIRootPages>
      </AuthUIProvider>
    ),
  },
];
